import React, {useEffect, useState} from "react";
import {Button, Form, Input, Modal, notification, Select, Switch} from "antd";
import {addCampaign, deleteCampaign, updateCampaignDetail} from "../../util/APIUtils";
import {showAxiosError} from "../../util/Helpers";
import TextArea from "antd/es/input/TextArea";
import {CheckOutlined, CloseOutlined} from "@ant-design/icons";

const {Option} = Select;

function CampaignModal(props) {
    const [form] = Form.useForm();
    const [campaignValue, setCampaignValue] = useState(props.campaignModalContent);
    const [formDisplay, setFormDisplay] = useState(false);
    const [formType, setFormType] = useState(false);
    const [hasCampaignCode, setHasCampaignCode] = useState(false);
    const [isActive, setIsActive] = useState(false);

    useEffect(() => {
        if (campaignValue === undefined) {
            form.setFieldsValue({});
        }
        if (campaignValue !== undefined) {
            setFormDisplay(campaignValue.formDisplay);
            setFormType(campaignValue.formType);
            setHasCampaignCode(campaignValue.hasCampaignCode);
            setIsActive(campaignValue.isActive);
            form.setFieldsValue({
                baseHeader: campaignValue.baseHeader,
                description: campaignValue.description,
                termsOfUse: campaignValue.termsOfUse,
                formDisplay: campaignValue.formDisplay,
                formType: campaignValue.formType,
                hasCampaignCode: campaignValue.hasCampaignCode,
                isActive: campaignValue.isActive,
            });
        }
    })

    function onFinish(values) {

        if (campaignValue === undefined) {
            addCampaign(values).then((response) => {
                notification.success({
                    message: "Başarılı",
                    description: "Kampanya başarılı bir şekilde kaydedildi.",
                })
            }).catch((error) => {
                showAxiosError(error.response);
            })
        }
        if (campaignValue !== undefined) {
            values.recordId = campaignValue.recordId;
            updateCampaignDetail(values).then((response) => {
                notification.success({
                    message: "Başarılı",
                    description: "Kampanya başarılı bir şekilde kaydedildi.",
                })
            }).catch((error) => {
                showAxiosError(error.response);
            })
        }
    }

    const handleOk = (e) => {
        form
            .validateFields()
            .then((values) => {
                onFinish(values);
                props.callbackModal();
            })
    };

    const handleCancel = (e) => {
        props.callbackModal();
    };

    const handleDeleteCampaign = (e) => {
        deleteCampaign(campaignValue.recordId).then((response) => {
            props.callbackModal();
            notification.success({
                message: "Başarılı",
                description: "Kampanya başarılı bir şekilde silindi.",
            })
        }).catch((error) => {
            showAxiosError(error.response);
        })
    }

    return (
        <div>
            <Modal
                title="Kampanya Detayları"
                visible={props.visible}
                onOk={handleOk}
                onCancel={handleCancel}
                okButtonProps={{
                    disabled: false,
                }}
                cancelButtonProps={{
                    disabled: false,
                }}
                okText="Kaydet"
                cancelText="İptal"
                footer={[
                    <Button
                        danger
                        key="delete"
                        type="primary"
                        onClick={handleDeleteCampaign}
                    >
                        Sil
                    </Button>,
                    <Button key="back" onClick={handleCancel}>
                        İptal
                    </Button>,
                    <Button key="submit" type="primary" onClick={handleOk}>
                        Kaydet
                    </Button>,
                ]}
            >
                <Form form={form} onFinish={onFinish} layout="vertical">
                    <Form.Item
                        label="Başlık"
                        name="baseHeader"
                    >
                        <Input type="text" name="baseHeader" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="Açıklama"
                        name="description"
                    >
                        <TextArea rows={4} placeholder="Kampanya açılamasını giriniz."/>
                    </Form.Item>
                    <Form.Item
                        label="Kullanım Koşulları"
                        name="termsOfUse"
                    >
                        <TextArea rows={4} placeholder="Kullanma koşullarını giriniz."/>
                    </Form.Item>
                    <Form.Item
                        label="Kampanya Fotoğrafı"
                        name="campaignImagePath"
                    >
                        <Input type="file" name="imagePath" size="large"/>
                    </Form.Item>
                    <Form.Item
                        label="Kampanya Kodu"
                        name="hasCampaignCode"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined/>}
                            unCheckedChildren={<CloseOutlined/>}
                            defaultChecked={hasCampaignCode}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Başvuru Formu Gösterimi"
                        name="formDisplay"
                    >
                        <Select
                            defaultValue={formDisplay}
                            style={{
                                width: 120,
                            }}
                            allowClear
                        >
                            <Option value={true}>Evet</Option>
                            <Option value={false}>Hayır</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Form Tipi"
                        name="formType"
                    >
                        <Select
                            defaultValue={formType}
                            style={{
                                width: 120,
                            }}
                            allowClear
                        >
                            <Option value="FUEL">Akaryakıt</Option>
                            <Option value="NORMAL">Normal</Option>
                        </Select>
                    </Form.Item>

                    <Form.Item
                        label="Kampanya Aktifliği"
                        name="isActive"
                    >
                        <Switch
                            checkedChildren={<CheckOutlined/>}
                            unCheckedChildren={<CloseOutlined/>}
                            defaultChecked={isActive}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>

    )
}

export default CampaignModal;


// WEBPACK FOOTER //
// ./src/component/Modal/modal.js